import React from "react";
import {Button, ButtonGroup, Row} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faPen, faTrash} from "@fortawesome/free-solid-svg-icons";
import "./IsolationHardwareActionCell.css";

const IsolationHardwareActionCell = props => (
  <Row style={{ display: "block" }}>
    <div className="floatRight">
    <ButtonGroup size="sm">
        <Button
            className="btn-green"
            onClick={(event) => {
                event.stopPropagation();
                props.onUpdate();
            }}
        >
            <FontAwesomeIcon icon={faPen} size="1x" />
        </Button>
        <Button
            className="btn-red btn-sm"
            onClick={event => {
                event.stopPropagation();
                props.onDelete();
            }}
        >
            <FontAwesomeIcon icon={faTrash} size="1x" />
        </Button>
    </ButtonGroup>
    </div>
  </Row>
);

export default IsolationHardwareActionCell;
